/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_DateInputs */

const en_form_date = /** @type {(inputs: Form_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date`)
};

const he_form_date = /** @type {(inputs: Form_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תאריך`)
};

/**
* | output |
* | --- |
* | "Date" |
*
* @param {Form_DateInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const form_date = /** @type {((inputs?: Form_DateInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_DateInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_date(inputs)
	return he_form_date(inputs)
});